import { c as _c } from "react/compiler-runtime";
import { CheckmarkCircleFillIcon, ExclamationmarkTriangleFillIcon, InformationSquareFillIcon, XMarkOctagonFillIcon } from "@navikt/aksel-icons";
import { BodyLong, Heading } from "@navikt/ds-react";
import { getShortDateFormat } from "@/utils/dateUtils";
import styles from "./componentheader.module.css";
interface Props {
  headerText: string;
  alertStyle: "info" | "success" | "warning" | "error";
  utsendtDato?: string | null;
}
export const ComponentHeader = t0 => {
  const $ = _c(21);
  const {
    headerText,
    alertStyle,
    utsendtDato
  } = t0;
  let t1;
  if ($[0] !== headerText) {
    t1 = <Heading size="large" level="1">{headerText}</Heading>;
    $[0] = headerText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== alertStyle) {
    t2 = alertStyle === "info" && <InformationSquareFillIcon aria-hidden={true} className={styles.infoIcon} />;
    $[2] = alertStyle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== alertStyle) {
    t3 = alertStyle === "warning" && <ExclamationmarkTriangleFillIcon aria-hidden={true} className={styles.warningIcon} />;
    $[4] = alertStyle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== alertStyle) {
    t4 = alertStyle === "success" && <CheckmarkCircleFillIcon aria-hidden={true} className={styles.successIcon} />;
    $[6] = alertStyle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== alertStyle) {
    t5 = alertStyle === "error" && <XMarkOctagonFillIcon aria-hidden={true} className={styles.errorIcon} />;
    $[8] = alertStyle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex flex-row mb-4 space-between">{t1}{t2}{t3}{t4}{t5}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== utsendtDato) {
    t7 = utsendtDato && <BodyLong textColor="subtle">Utsendt {getShortDateFormat(utsendtDato)}</BodyLong>;
    $[16] = utsendtDato;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="mb-4">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};